// extracted by mini-css-extract-plugin
export var button = "styles-module--button--c362e";
export var content = "styles-module--content--3ac0a";